import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";

const updateReview = async (payload: any)=>{
    const { data } = await axios.put(Apis.CREATE_REVIEWS, payload, { headers: { Authorization: getToken() } });
    return data;
}

export default updateReview;